import React from "react";
import QualitativeChart from "./QualitativeChart";

const QualitativeTypeBasedComponentMap = {
};

const IndicatorUUIDBasedComponentMap = {
};

const DefaultComponent = QualitativeChart;

const QualitativeChartFactory = ({ indicatorDTO, objective }) => {
    const IndicatorUUIDComponent = IndicatorUUIDBasedComponentMap[indicatorDTO.indicatorUUID];
    if (IndicatorUUIDComponent) {
        return <IndicatorUUIDComponent indicatorDTO={indicatorDTO} objective={objective} />;
    }
    const QualitativeTypeComponent = QualitativeTypeBasedComponentMap[indicatorDTO.qualitativeTypeDTO.qualitativeTypeId];
    if (QualitativeTypeComponent) {
        return <QualitativeTypeComponent indicatorDTO={indicatorDTO} objective={objective} />;
    }
    return <DefaultComponent indicatorDTO={indicatorDTO} objective={objective} />;
}

export default QualitativeChartFactory;